import React, { useEffect, useRef, useState } from 'react'
import Header from '../../components/header/header'
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { getCampaignListAction, reviewCampaignAction } from '../../actions/peopleai';
import { useNavigate } from 'react-router';
import { RoutesPaths } from '../../Router/constant';
import CampaignConfirmation from './CampaignConfirmation';
import Select from "react-select";
import { Controller, useForm, useWatch } from 'react-hook-form';
import { appUrl, CUSTOM_SELECT_STYLES, SELECT_BOX_THEME } from '../../constants';
import TimeFormat from '../../components/timeFormat/timeFormat';

export default function CampaignList() {
    const [page, setPage] = useState(1);
    const [activePage, setActivePage] = useState(0);
    const navigate = useNavigate()
    const [search, setSearch] = useState("");
    const dispatch = useDispatch();
    const { campaignList, campaignListCount } = useSelector((state) => state.peopleai);
    const { control } = useForm();
    const status = useWatch({ control, name: "status" });
    const timeoutRef = useRef(null);

    const [confirmAcceptRejectModal, setConfirmAcceptRejectModal] = useState(false);
    const [campaign, setCampaign] = useState(null);

    const campaignStatusOptions = [
        { label: "Launched", value: "launched" },
        { label: "In progress", value: "inprogress" },
        { label: "Draft", value: "draft" },
    ];

    useEffect(() => {
        setPage(1);
        setActivePage(0);
    }, [search, status]);

    useEffect(() => {
        clearTimeout(timeoutRef.current);

        timeoutRef.current = setTimeout(() => {
            dispatch(getCampaignListAction(page, 20, search, status?.value || ""));
        }, search ? 500 : 0);

        return () => clearTimeout(timeoutRef.current);
    }, [dispatch, page, search, status]);

    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        setActivePage(selectedPage);
        setPage(selectedPage + 1);
    };

    const handleNavigate = (item) => {
        navigate(RoutesPaths.CAMPAIGN_DETAIL.replace(":id", item?.slug ? item?.slug : item.id))
    }

    const handleCampaignLinkRedirect = (item) => {
        window.open(
            `${appUrl}c/${item?.slug ? item?.slug : item?.id}`,
            "_blank"
        );
    };


    const handleUserLinkRedirect = (item) => {
        let companyId = item?.company?._id || item?.company?.id;
        window.open(
            `${appUrl}ud/${companyId}`,
            "_blank"
        );
    };
    const onSubmitApproval = async (item) => {
        await dispatch(reviewCampaignAction(item?.id));
        dispatch(getCampaignListAction(1, 20, search, status?.value || ""));
        setActivePage(0);
        setPage(1);
    };

    return (
        <>
            <Header title="Campaign manager" />
            <CampaignConfirmation
                show={confirmAcceptRejectModal}
                onClose={() => setConfirmAcceptRejectModal(false)}
                campaign={campaign}
                onSubmitApproval={onSubmitApproval}
                isDefault={true}
            />
            <div className="container-fluid py-4">
                <div className="row">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12 mb-2">
                        <div className="card planList notification h-100">
                            <div className="card-header">
                                <div className="searchbar">
                                    <input
                                        type="search"
                                        placeholder="Search campaign by name.."
                                        name="search"
                                        id=""
                                        autoComplete="off"
                                        value={search}
                                        onChange={(e) => {
                                            setSearch(e.target.value.trimLeft());
                                        }}
                                    />
                                    <img src="assets/img/searchIcon.svg" alt="" />
                                </div>
                                <div className='statusFilterProfile'>
                                    <Controller
                                        name="status"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                theme={SELECT_BOX_THEME}
                                                styles={CUSTOM_SELECT_STYLES}
                                                className="select-border"
                                                options={campaignStatusOptions}
                                                isClearable
                                                placeholder="Status"
                                                components={{ IndicatorSeparator: () => null }}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="card-body detail">
                                <table className="businessTable userTable">
                                    <thead>
                                        <tr>
                                            <td>Campaign name</td>
                                            <td>From user</td>
                                            <td>Status</td>
                                            <td>Updated at</td>
                                            <td>Action</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {campaignList.length > 0 ? (
                                            campaignList?.map((ele, eleIndex) => (
                                                <tr key={eleIndex}>
                                                    <td>
                                                        <h6
                                                            className="profile-text text-sm cursor-pointer"
                                                            onClick={() => handleCampaignLinkRedirect(ele)}
                                                        >
                                                            {ele.name || "-"}
                                                        </h6>
                                                    </td>
                                                    <td>
                                                        <h6 className="profile-text profile-text-fromuser text-sm cursor-pointer"
                                                            onClick={() => handleUserLinkRedirect(ele)}>
                                                            {ele?.creator?.first_name || "-"}{" "}
                                                            {ele?.creator?.last_name && ele?.creator?.last_name} ({ele?.company?.isDefault ? "advisor" : ele?.company?.companyName})
                                                        </h6>
                                                    </td>
                                                    <td>
                                                        <h6 className="profile-text profile-text-fromuser text-sm">
                                                            {ele?.status === "inprogress" ? "In progress" : ele?.status === "draft" ? "Draft" : ele?.status === "launched" ? "Launched" : "" || "-"}{" "}
                                                        </h6>
                                                    </td>
                                                    <td>
                                                        <h6 className="profile-text profile-text-fromuser text-sm">
                                                            <TimeFormat time={ele?.updatedAt} />
                                                        </h6>
                                                    </td>
                                                    <td>
                                                        <div className="">
                                                            {ele?.status === "inprogress" ?
                                                                <button
                                                                    onClick={() => {
                                                                        setCampaign(ele);
                                                                        setConfirmAcceptRejectModal(true);
                                                                    }}
                                                                    className="btn save-btn editButton"
                                                                >
                                                                    Approve
                                                                </button>
                                                                :
                                                                <button
                                                                    disabled={ele?.status !== "launched"}
                                                                    onClick={() => handleNavigate(ele)}
                                                                    className="btn save-btn editButton"
                                                                >
                                                                    View
                                                                </button>
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr className="d-flex pt-3">
                                                <td className="d-flex flex-column justify-content-center">
                                                    <h6 className="mb-0 text-sm table-heading text-center">
                                                        No users found
                                                    </h6>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            {campaignListCount > 1 && (
                                <div className="pagination-section">
                                    <ReactPaginate
                                        previousLabel={"Prev"}
                                        nextLabel={"Next"}
                                        breakLabel={"..."}
                                        breakClassName={"break-me"}
                                        pageCount={campaignListCount}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={3}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination"}
                                        subContainerClassName={"pages pagination"}
                                        activeClassName={"active"}
                                        forcePage={activePage}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
